export const FadeInAndOutDuration = 250; // duration is milliseconds

export const AutoCloseTimeout = 10000; // duration is milliseconds

export const IPopup = ({
  open = false,
  timeout = AutoCloseTimeout,
  title = '',
  type = '',
  message = '',
  content = <></>,
  onOk = () => {},
}) => ({
  open,
  timeout,
  title,
  type,
  message,
  content,
  onOk,
});
